<div class="app-container">
  <!-- Top App Bar -->
  <mat-toolbar color="primary" class="nbcu-toolbar">
    <mat-toolbar-row class="headerRow">
      <img class="nbcLogo" src="/assets/NBCUniversal_white-ec985d04.svg" alt="NBCUniversal Logo">
      <h2 class="spacer">Studio Pulse API</h2>
      <!-- Add any toolbar actions here -->
    </mat-toolbar-row>
  </mat-toolbar>

  <!-- Main Layout Container -->
  <mat-sidenav-container class="h-screen">

    <!-- Sidebar -->
    <mat-sidenav #snav mode="side" opened="true" class="w-[240px] overflow-y-auto dark:bg-[#121212]">
      <ng-ema-sidebar class="nav-sideBar"></ng-ema-sidebar>
    </mat-sidenav>

    <!-- Main Content -->
    <mat-sidenav-content class="dark:bg-[#121212] dark:text-white">
      <div class="p-4">
        <div class="app-content">
          <router-outlet></router-outlet>
        </div>
        <div>
          <footer class="app-footer" *ngIf="version && envName">
            Version {{ version }} - {{ envName }}
          </footer>
        </div>
      </div>
    </mat-sidenav-content>

  </mat-sidenav-container>
</div>